/*
 * Copyright © Manatee. 2026 All Rights Reserved.
 * Proprietary and confidential.
 */

import { TriangleAlert } from "lucide-react";
import { cn } from "../../lib/utils";

interface ErrorMessageProps {
  message?: string | null;
  description?: string | null;
  className?: string;
}

export function ErrorMessage({
  message,
  description,
  className,
}: ErrorMessageProps) {
  if (!message) return null;

  return (
    <div role="alert" className={cn("relative mb-6 animate-fade-slide-in", className)}>
      <div className="rounded-2xl border border-error-border bg-error-bg px-4 py-3 flex gap-3 items-center">
        <div className="flex-shrink-0">
          <TriangleAlert size={22} className="text-error" />
        </div>

        <div className="flex-1 min-w-0">
          <p className="text-sm leading-relaxed text-error">{message}</p>

          {description && (
            <p className="text-error/70 text-sm leading-relaxed mt-1">
              {description}
            </p>
          )}
        </div>
      </div>
    </div>
  );
}
